import { render, staticRenderFns } from "./rongyu-zizhi.vue?vue&type=template&id=597da68a&"
import script from "./rongyu-zizhi.vue?vue&type=script&lang=js&"
export * from "./rongyu-zizhi.vue?vue&type=script&lang=js&"
import style0 from "./rongyu-zizhi.vue?vue&type=style&index=0&id=597da68a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports